module.exports = __webpack_public_path__ + "img/9788949123295.3feb986f.jpg";